var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"product-variant-button",class:{
    'product-variant-button--active': _vm.active,
    'product-variant-button--disabled': _vm.disabled,
  },attrs:{"title":_vm.inactive ? 'Indisponível' : _vm.description,"disabled":_vm.inactive}},[(_vm.image)?_c('div',{staticClass:"product-variant-button-img-wrapper"},[_c('ImageItem',{attrs:{"custom-class":"img img-responsive","source":_vm.image,"description":_vm.description}})],1):_c('span',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }